import React, { Component } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import Axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import DataTable from '../DataTable';
import { taskStateToString } from '../../../Utils/Converters';
import { ALL } from '../../../Data/Constants';
import TaskRegistrationsSection from '../TaskRegistrationsAdmin/TaskRegistrationsSection';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />
}


class TasksAdminPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            event: null
        };
    }

    componentDidMount() {
        Axios.get(`/admin/events/${this.eventId}`).then(res => {
            this.setState({ event: res });
        });
    }
    eventId = this.props.params.eventId;

    columns = [
        {
            header: 'Név',
            id: 'name',
            cell: row => <NavLink to={`/admin/events/${this.eventId}/tasks/${row.id}`}>{row.name}</NavLink>
        },
        {
            header: 'Határidő',
            accessor: 'deadline',
            filterable: false,
            cell: row => (
                <span>{new Date(row).toLocaleString("hu")}</span>
            )
        },
        {
            header: 'Állapot',
            accessor: 'state',
            cell: row => (
                <span>{taskStateToString(row)}</span>
            ),
            Filter: ({ filter, onChange }) =>
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : { ALL }}
                >
                    <option value={ALL}>Mind mutatása</option>
                    {new Array(3).fill(0).map((value, index) => {
                        return <option value={index} key={index}>{taskStateToString(index)}</option>
                    })}
                </select>
        },
        {
            header: 'Max. adható pont',
            accessor: 'pointValue',
            filterable: false
        },
        {
            header: 'Létrehozva',
            id: 'creationDate',
            filterable: false,
            cell: row => (
                <span>
                    {new Date(row.creationDate).toLocaleString("hu")}{' '}
                    <small><em>({row.createdByUserName})</em></small>
                </span>
            )
        },
        {
            header: 'Utoljára módosítva',
            id: 'lastModificationDate',
            filterable: false,
            cell: row => {
                if (row.lastModificationDate !== null)
                    return <span>
                        {new Date(row.lastModificationDate).toLocaleString("hu")}{' '}
                        <small><em>({row.lastModifiedByUserName})</em></small>
                    </span>
                else return null;
            }
        }
    ];

    render() {
        return (
            <>
                <h1>Feladatok{this.state.event && ` - ${this.state.event.name}`}</h1>
                <DataTable url={`/admin/events/${this.eventId}/tasks`} columns={this.columns} SubComponent={row => (
                    <TaskRegistrationsSection registrations={row.original.registrations} task={row.original} />
                )}
                />
                <NavLink className="btn btn-primary" to={`/admin/events/${this.eventId}/tasks/create`}><FontAwesomeIcon icon={faPlus} /> Új feladat</NavLink>
            </>
        );
    }
}

export default withParams(TasksAdminPage);
